import { render, staticRenderFns } from "./storesDeposit.vue?vue&type=template&id=5be7b858"
import script from "./storesDeposit.vue?vue&type=script&lang=js"
export * from "./storesDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports